import { createAsyncThunk } from "@reduxjs/toolkit";
import * as URL from "helpers/url_helper";
import { post } from "helpers/api_helper";

export const getPrescriptionMailList = createAsyncThunk(
  "getPrescriptionMailList",
  async ({ data, callback }, Thunk) => {
    console.log(data, "data======mail payload");
    try {
      let response = await post(`${URL.PRESCRIPTION_MAIL}`, data);
      console.log("response callback==>", response);
      callback && callback(null, response);
      return response;
    } catch (error) {
      console.log(error, "error message ");
      callback && callback(error);
      return Thunk.rejectWithValue(error);
    }
  }
);

